<main class="c-main" role="main">
    <div class="c-page-incomingrequest">
        <div class="container u-pb30">
            <div class="row mobile--orange u-pt40">
                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a [routerLink]="['/']"> {{'PolicyRequestListPortal.home' | translate}} </a></li>
                            <li class="breadcrumb-item active" aria-current="page"> &nbsp;- <span> {{ 'PolicyRequestListPortal.location' | translate}}</span></li>
                        </ol>
                    </nav>
                    <h2 class="o-title"> {{'PolicyRequestListPortal.title' | translate}} </h2>
                    <br>
                    <h4> {{'PolicyRequestListPortal.subtitle' | translate}}</h4>
                </div>
            </div>
        </div>

        <div class="content-filter">
            <div class="content-filter__group">
                <span></span>
                <input (keyup.enter)="getallpolicyFilter()" min="0" style="background-color: white;" [(ngModel)]="requestF" class="o-form__input" type="number" placeholder="{{'PolicyRequestListPortal.placeholderFilterNumber'| translate}}" numbersOnly >
                <div *ngIf="isNegative(requestF)" style="width:100%; background-color: #F2F0E9">
                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'PolicyRequestListPortal.noNegativeNumber'| translate}}</mat-error></h5></span>
                </div>
            </div>

            <div class="content-filter__group">
                <span></span>
                <select name="typeSelect" (change)="getallpolicyFilter()" [(ngModel)]="typeF" class="o-form__select" required> 
                    <option ngValue=''  >{{'PolicyRequestListPortal.typeFilter'| translate}}</option>
                    <option *ngFor="let type of typesSelect" [ngValue]="type.id"> {{type.name | titlecase}}</option>
                  </select>


            </div>
            <div class="content-filter__group">
                <span></span>
                <select name="statusSelect" (change)="getallpolicyFilter()" [(ngModel)]="statusF" class="o-form__select" required> 
                    <option ngValue=''  >{{'PolicyRequestListPortal.statusFilter'| translate}}</option>
                    <option  *ngFor="let status of statusSelect" [ngValue]="status.id"> 
                        <p *ngIf="status.name=='Pending'">{{'PolicyRequestListPortal.pendingStatus'| translate}}</p>
                        <p *ngIf="status.name=='Approved'">{{'PolicyRequestListPortal.approvedStatus'| translate}}</p>    
                        <p *ngIf="status.name=='Reject'">{{'PolicyRequestListPortal.rejectStatus'| translate}}</p>    
                        <p *ngIf="status.name=='Scaled'">{{'PolicyRequestListPortal.ScaledStatus'| translate}}</p>     
                    </option>
                
                  </select>


            </div>
        </div>

        <div class="container u-pb30">
            <div class="row">
                <div class="col-md-12">

                    <div class="c-search">
                        <tr>
                            <td>
                                <p style="padding: 10px;">
                                    <span class="table__mobile"> </span>
                                    <button class="btn btn--primary open_modal" (click)="clearFilter()" mat-raised-button>{{'PolicyRequestListPortal.btnClearFilter'| translate}}</button>
                                </p>
                            </td>
                            <td>
                                <p>
                                    <span class="table__mobile"> </span>
                                    <button class="btn btn--primary open_modal" [disabled]="isNegative(requestF)" (click)="getallpolicyFilter()" mat-raised-button>{{'PolicyRequestListPortal.btnApplyFilter'| translate}}</button>
                                </p>
                            </td>
                        </tr>
                    </div>
                    <table class="table table-bordered table-striped table-condensed">
                        <thead>
                            <tr>
                                <th>
                                    <p> <a (click)="orderby('requestNumber', requestDesc)"><span  >{{'PolicyRequestListPortal.colRequestNumber' | translate}}</span>
                                        <i *ngIf="!requestDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i> 
                                        <i *ngIf="requestDesc"style="cursor: pointer; transform: rotate(90deg);" class="icon icon-arrow icon-arrow-down"></i> 
                                      </a>
                                    </p>

                                </th>
                                <th>
                                    <p><a (click)="orderby('type', typeDesc)"><span >{{'PolicyRequestListPortal.colType' | translate}}</span>
                                        <i *ngIf="!typeDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i> 
                                        <i *ngIf="typeDesc"style="cursor: pointer; transform: rotate(90deg);" class="icon icon-arrow icon-arrow-down"></i> 
                                    </a>

                                    </p>

                                </th>
                                <th>
                                    <p><a (click)="orderby('status', statusDesc)"><span >{{'PolicyRequestListPortal.colStatus' | translate}}</span>
                                        <i *ngIf="!statusDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i> 
                                        <i *ngIf="statusDesc"style="cursor: pointer; transform: rotate(90deg);" class="icon icon-arrow icon-arrow-down"></i> 
                                      </a>
                                    </p>
                                </th>
                                <th>
                                    <p><a><span >{{'PolicyRequestListPortal.colCommentary' | translate}}</span> 
                                      </a>
                                    </p>
                                </th>
                                <th>
                                    <p><a><span >{{'PolicyRequestListPortal.colObservations' | translate}}</span>
                                      </a>
                                    </p>
                                </th>
                                <th>
                                    <p><a><span >{{'PolicyRequestListPortal.colDetails' | translate}}</span>
                                      </a>
                                    </p>
                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let seeAllPolicies of SeeAllPolicies">

                                <td class="table__title-row" style="text-align: center;">
                                    <p> <strong> {{ seeAllPolicies.policyId }}  </strong> </p>
                                </td>

                                <td *ngIf="getlang()==='en'" title="{{seeAllPolicies.typeEnNames | titlecase}}" style="text-align: center;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;">

                                    <strong>{{ seeAllPolicies.typeEnNames | titlecase}} </strong>

                                </td>
                                <td *ngIf="getlang()==='es'" title="{{seeAllPolicies.typeEsNames | titlecase}}" style="text-align: center;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;">


                                    <strong> {{ seeAllPolicies.typeEsNames | titlecase }} </strong>

                                </td>
                                <td>
                                    <p> <strong class="table__mobile">{{'PolicyRequestListPortal.colStatus' | translate}}: </strong>
                                        <i *ngIf="seeAllPolicies.status=='Pending'" class="icon icon-more">  </i>
                                        <i *ngIf="seeAllPolicies.status=='Scaled'" class="icon icon-arrow" style=" transform: rotateY(180deg);">  </i>
                                        <i *ngIf="seeAllPolicies.status=='Reject'" class="icon icon-close">  </i>
                                        <i *ngIf="seeAllPolicies.status=='Approved'" class="icon icon-check">  </i>
                                        <span *ngIf="seeAllPolicies.status=='Pending'">{{'PolicyRequestListPortal.pendingStatus'| translate}} </span>
                                        <span *ngIf="seeAllPolicies.status=='Scaled'">&nbsp; {{'PolicyRequestListPortal.ScaledStatus'| translate}} </span>
                                        <span *ngIf="seeAllPolicies.status=='Reject'">{{'PolicyRequestListPortal.rejectStatus'| translate}} </span>
                                        <span *ngIf="seeAllPolicies.status=='Approved'">{{'PolicyRequestListPortal.approvedStatus'| translate}} </span>
                                    </p>
                                </td>
                                <td>
                                    <p> <span class="table__mobile">{{'PolicyRequestListPortal.colCommentary' | translate}}: </span>{{ seeAllPolicies.commentary}}</p>
                                </td>
                                <td style="text-align: center;">

                                    <a (click)="openDialogObs(seeAllPolicies)" style="cursor:pointer">
                                        <img src="../assets/img/icn/ICONO/LUPA/BLANCA.svg" alt="">
                                    </a>

                                </td>
                                <td style="text-align: center;">
                                    <p>
                                        <a class="logo" [routerLink]="['/policy/detail/','request',   seeAllPolicies.policyId ]" title="{{'PolicyRequestListPortal.tipSeeDetails' | translate}}">
                                            <img src="../assets/img/icn/ICONO/ARCHIVO.svg" alt="">
                                        </a>
                                    </p>
                                </td>
                            </tr>

                        </tbody>
                    </table>

                </div>
                <div class="col-md-12">
                    <hr class="big">
                    <div class="row pagination-main">
                        <div class="col-md-6">

                        </div>
                        <div class="col-md-6">
                            <ul class="pagination">

                                <mat-paginator #paginator [length]="totalItems" [pageSize]="pageSize" (page)="handlePage($event)" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>